import * as React from 'react'

import Svg, {
  ClipPath,
  Defs,
  G,
  Path,
  RadialGradient,
  Rect,
  Stop,
} from 'react-native-svg'

const VisitingCardSmallSVG = ({ ...props }) => {
  return (
    <Svg
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G clipPath="url(#clip0_103_2572)">
        <Rect x={-0.00012207} width={48} height={48} rx={8} fill="#F2F7FF" />
        <Path
          d="M47.66 37.073L28.112 19.925a1.08 1.08 0 00-1.525.1L15.162 33.048a1.08 1.08 0 00.1 1.525L34.81 51.722a1.08 1.08 0 001.525-.1L47.76 38.599a1.08 1.08 0 00-.1-1.525z"
          fill="url(#paint0_radial_103_2572)"
        />
        <Path
          d="M52.2 35.227L28.62 14.543c-.541-.475-1.346-.443-1.796.071l-13.09 14.923c-.451.514-.378 1.315.163 1.79l23.582 20.685c.54.474 1.345.443 1.796-.072l13.09-14.922c.45-.514.377-1.316-.164-1.79z"
          fill="url(#paint1_radial_103_2572)"
        />
        <Path
          d="M34.007 26.562l-5.365-4.706c-.54-.473-1.276-.515-1.645-.094l-5.328 6.074c-.37.421-.232 1.146.307 1.62l5.365 4.705c.539.473 1.276.515 1.645.093l5.328-6.073c.37-.422.232-1.146-.307-1.62z"
          fill="#F2F7FF"
        />
        <Path
          d="M41.148 41.595l-6.315-5.54c-.541-.474-1.345-.442-1.796.072-.451.514-.378 1.316.163 1.79l6.315 5.54c.542.474 1.346.443 1.797-.071.45-.515.378-1.316-.164-1.79zM36.495 34.162l3.02 2.649c.54.475 1.345.443 1.796-.071.451-.514.378-1.316-.163-1.79l-3.02-2.65c-.541-.474-1.346-.443-1.797.072-.45.514-.378 1.315.164 1.79z"
          fill="#fff"
        />
      </G>
      <Defs>
        <RadialGradient
          id="paint0_radial_103_2572"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(-175.157 22.934 16.923) scale(30.7693 25.675)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#CD9A58" />
        </RadialGradient>
        <RadialGradient
          id="paint1_radial_103_2572"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-34.89984 -3.71678 3.2552 -30.56565 50.279 35.475)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <ClipPath id="clip0_103_2572">
          <Rect x={-0.00012207} width={48} height={48} rx={8} fill="#fff" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default VisitingCardSmallSVG
